<template>
  <div class="ibox services">
    <div class="ibox-title col-md-12 col-lg-12 col-sm-12 col-xs-12 services_head white-gray">
      <div class="inline appointments">
        &nbsp;
        <i class="fa fa-calendar"></i>
        Scheduled Appointments
      </div>
      <div class="inline timezone" v-if="isVirtual">&nbsp;
          <i class="fa fa-globe"></i>
          {{ timezone }} &nbsp;
      </div>
    </div>
    <div class="ibox-content services_content add_ppadding ">
      <img src="/pic/image-loader.gif" class="center" width="40" v-if="loading"/>
      <booking-view-scheduled-visit v-for="(visit,index) of visits" :key="JSON.stringify(originalIds[index])"
                                    :visit="visit" :visitBreakDownIds="originalIds[index]" :is-virtual="isVirtual" ></booking-view-scheduled-visit>
    </div>
  </div>
</template>

<script>
import {getBookingVisits} from "@/modules/Booking/api/visits";

export default {
  name: "BookingViewScheduledVisits",
  props: {
    bookingId: Number,
    isVirtual: {
      type:Boolean,
    required: true,
      default(){
        return false;
      }
    },
    timezone: {
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      visits: [],
      originalIds: [],
      loading: true
    }
  },
  created() {
    getBookingVisits(this.bookingId).then((response) => {
      this.visits = (response.data || {}).merged_visits
      this.originalIds = (response.data || {}).original_ids
      this.loading = false
    })
  },
  mounted() {

  }
}
</script>

<style scoped>

  .ibox-content {
    background-color: #d9dee1 !important
  }
  .add_ppadding{
    padding-right: 8px ;
    padding-left: 8px ;
  }
  .center {
    margin: 0;
    position: relative;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
  
  .timezone {
    text-align: right;
    float: right;
  }
  
  @media only screen and (max-width: 600px) {
    .timezone {
      margin-top: 10px;
      text-align: left !important;
      float: left !important;
      display: block !important;
    }
    .appointments {
      display: block !important;
    }
  }

</style>
